const MARKLIST = [{
  key: 'POLICY',
  value: '保单数'
}, {
  key: 'PREMIUM',
  value: '保费数'
}, {
  key: 'CLAIMS',
  value: '理赔报案数'
}, {
  key: 'ORDER',
  value: '订单数'
}, {
  key: 'NEW_USER',
  value: '新增用户'
}, {
  key: 'CLAIMS-PEIFUJINE',
  value: '赔付金额'
}, {
  key: 'CLAIMS-GUSUNJINE',
  value: '估损金额'
}];
const TYPELIST = [{
  key: 'POLICY_PREMIUM',
  value: '保单保费'
}, {
  key: 'CLAIMS',
  value: '理赔数据'
}, {
  key: 'ACHIEVEMENT',
  value: '业绩分析'
}];
const ROLELIST = [{
  key: 'TOTAL_SYSTEM',
  value: '总系统'
}, {
  key: 'INSURANCE_AGENCY',
  value: '保险机构'
}, {
  key: 'INTERMEDIARY_AGENCY',
  value: '中介机构'
}, {
  key: 'ORDINARY',
  value: '普通客户'
}];
const MENULIST = [{
  key: 'HOME_PAGE',
  value: '首页'
}, {
  key: 'DATA_BOARD',
  value: '数据看板'
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  current: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};
const COLUMNS = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '面板名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  slots: {
    title: '标识'
  },
  dataIndex: 'mark',
  key: 'mark',
  align: 'center',
  scopedSlots: {
    customRender: 'mark'
  }
}, {
  slots: {
    title: '菜单'
  },
  dataIndex: 'menu',
  key: 'menu',
  align: 'center',
  scopedSlots: {
    customRender: 'menu'
  }
}, {
  slots: {
    title: '面板分类'
  },
  dataIndex: 'type',
  key: 'type',
  align: 'center',
  scopedSlots: {
    customRender: 'type'
  }
}, {
  slots: {
    title: '使用角色'
  },
  dataIndex: 'role',
  key: 'role',
  align: 'center',
  scopedSlots: {
    customRender: 'role'
  }
}, {
  slots: {
    title: '操作'
  },
  key: '6',
  align: 'center',
  width: 200,
  scopedSlots: {
    customRender: 'action'
  }
}];
const SOURCE = {
  TOTAL_SYSTEM: [{
    key: 'ISSUE_CUSTOMER',
    value: '出单客户'
  }, {
    key: 'INSURANCE_AGENCY',
    value: '保险机构'
  }, {
    key: 'INSURANCE',
    value: '保险产品'
  }, {
    key: 'INTERMEDIARY_AGENCY',
    value: '中介机构'
  }],
  INSURANCE_AGENCY: [{
    key: 'ISSUE_CUSTOMER',
    value: '出单客户'
  }, {
    key: 'INTERMEDIARY_AGENCY',
    value: '中介机构'
  }, {
    key: 'INSURANCE',
    value: '保险产品'
  }],
  INTERMEDIARY_AGENCY: [{
    key: 'ISSUE_CUSTOMER',
    value: '出单客户'
  }, {
    key: 'INSURANCE_AGENCY',
    value: '保险机构'
  }, {
    key: 'INSURANCE',
    value: '保险产品'
  }],
  ORDINARY: [{
    key: 'INTERMEDIARY_AGENCY',
    value: '中介机构'
  }, {
    key: 'INSURANCE_AGENCY',
    value: '保险机构'
  }, {
    key: 'INSURANCE',
    value: '保险产品'
  }]
};
const SOURCE2 = {
  INSURANCE_AGENCY: [{
    key: 'ISSUE_CUSTOMER',
    value: '出单客户'
  }, {
    key: 'INTERMEDIARY_AGENCY',
    value: '中介机构'
  }, {
    key: 'INSURANCE',
    value: '保险产品'
  },
  // {key: 'ACCOUNT', value: '账号架构'},
  {
    key: 'PERSONAL',
    value: '个人账号'
  }],
  INTERMEDIARY_AGENCY: [{
    key: 'ISSUE_CUSTOMER',
    value: '出单客户'
  }, {
    key: 'INSURANCE_AGENCY',
    value: '保险机构'
  }, {
    key: 'INSURANCE',
    value: '保险产品'
  },
  // {key: 'ACCOUNT', value: '账号架构'},
  {
    key: 'PERSONAL',
    value: '个人账号'
  }],
  ORDINARY: [{
    key: 'INTERMEDIARY_AGENCY',
    value: '中介机构'
  }, {
    key: 'INSURANCE_AGENCY',
    value: '保险机构'
  }, {
    key: 'INSURANCE',
    value: '保险产品'
  },
  // {key: 'ACCOUNT', value: '账号架构'},
  {
    key: 'PERSONAL',
    value: '个人账号'
  }]
};
export { MARKLIST, TYPELIST, ROLELIST, MENULIST, pagination, COLUMNS, SOURCE, SOURCE2 };